import { render, staticRenderFns } from "./role-layout.vue?vue&type=template&id=e33bf144&scoped=true&"
import script from "./role-layout.vue?vue&type=script&lang=js&"
export * from "./role-layout.vue?vue&type=script&lang=js&"
import style0 from "./role-layout.vue?vue&type=style&index=0&id=e33bf144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33bf144",
  null
  
)

export default component.exports